import React from 'react';
import { Tooltip, useTheme } from '@mui/material';

const WidgitPointToggle = ({ onToggle, enabled = false, disabled = false }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const imgBase = isDark ? '/point/buttons/dark_background' : '/point/buttons/light_background';
  return (
    // <Tooltip title={
    //   disabled ? 
    //     "Widgit is automatically enabled for students in Grade 4 or below" :
    //     (enabled ? "Turn Point symbols off" : "Turn Point symbols on")
    // }>
      <button
        onClick={() => !disabled && onToggle && onToggle(!enabled)}
        disabled={disabled}
        style={{
          border: 'none',
          background: 'none',
          cursor: disabled ? 'not-allowed' : 'pointer',
          padding: '4px',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '113px',
          minHeight: '32px',
          borderRadius: '4px',
          transition: 'background-color 0.2s',
          opacity: disabled ? 0.6 : 1
        }}
      >
        <img
          src={enabled ? `${imgBase}/on.gif` : `${imgBase}/off.gif`}
          alt={enabled ? "Symbols on" : "Symbols off"}
          width="113"
          height="32"
          style={{
            objectFit: 'contain',
            verticalAlign: 'middle',
            pointerEvents: 'none'
          }}
        />
      </button>
    // </Tooltip>
  );
};

export default WidgitPointToggle; 